<script setup lang="ts">
defineProps<{
  name:
    | "bowling"
    | "billiard"
    | "tennis"
    | "cinema"
    | "cinema3d"
    | "pingpong"
    | "console"
    | "shooting"
    | "arcade"
    | "babysitter"
    | "parking"
    | "football"
    | "volleyball"
    | "basketball"
    | "gym"
    | "bike";
  class?: string;
}>();
</script>

<template>
  <svg
    v-if="name === 'bowling'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="17" cy="14" r="5" />
    <circle cx="15.5" cy="12.5" r="0.6" fill="currentColor" />
    <circle cx="18" cy="12" r="0.6" fill="currentColor" />
    <circle cx="16" cy="15.5" r="0.6" fill="currentColor" />
    <path d="M6 4v14M4.5 18h3M5 4.5c1-.5 2-.5 3 0" />
  </svg>

  <svg
    v-else-if="name === 'billiard'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="6" />
    <circle cx="12" cy="12" r="2.2" fill="currentColor" stroke="none" />
    <text
      x="12"
      y="13.8"
      text-anchor="middle"
      font-size="3"
      fill="white"
      stroke="none"
    >8</text>
  </svg>

  <svg
    v-else-if="name === 'tennis'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="9" cy="9" r="5" />
    <path d="M5.5 5.5c2 2 5 2 7 0M12.5 12.5c-2 2-5 2-7 0" />
    <path d="M12.7 12.7l6 6M18 17l2 2" />
  </svg>

  <svg
    v-else-if="name === 'cinema'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="3" y="5" width="18" height="12" rx="1.5" />
    <path d="M3 9h18M3 13h18M6 5v12M18 5v12" />
    <path d="M8 19h8" />
  </svg>

  <svg
    v-else-if="name === 'cinema3d'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M3 9a3 3 0 013-3h12a3 3 0 013 3v3a3 3 0 01-3 3h-3.5L12 18l-2.5-3H6a3 3 0 01-3-3V9z" />
    <circle cx="9" cy="10.5" r="2" />
    <circle cx="15" cy="10.5" r="2" />
  </svg>

  <svg
    v-else-if="name === 'pingpong'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="9.5" cy="9.5" r="5" />
    <path d="M13 13l5.5 5.5M17 17.5l2 2" />
    <circle cx="18" cy="7" r="1.3" />
  </svg>

  <svg
    v-else-if="name === 'console'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path d="M6 9h12a3 3 0 013 3v2a3 3 0 01-5.5 1.5L14 14h-4l-1.5 1.5A3 3 0 013 14v-2a3 3 0 013-3z" />
    <path d="M7.5 12v2M6.5 13h2" />
    <circle cx="16" cy="12.5" r="0.7" fill="currentColor" stroke="none" />
    <circle cx="17.5" cy="13.5" r="0.7" fill="currentColor" stroke="none" />
  </svg>

  <svg
    v-else-if="name === 'shooting'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="5" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="12" r="0.6" fill="currentColor" stroke="none" />
  </svg>

  <svg
    v-else-if="name === 'arcade'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="6" y="3" width="12" height="18" rx="2" />
    <rect x="8" y="5" width="8" height="5" rx="0.5" />
    <circle cx="10" cy="14" r="1" />
    <circle cx="14" cy="14" r="1" />
    <path d="M9 18h6" />
  </svg>

  <svg
    v-else-if="name === 'babysitter'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="6" r="2.5" />
    <path d="M7.5 21v-6.5a4.5 4.5 0 019 0V21" />
    <path d="M9.5 10.5c1.5 1 3.5 1 5 0" />
  </svg>

  <svg
    v-else-if="name === 'parking'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="4" y="4" width="16" height="16" rx="3" />
    <path d="M10 16v-8h3.5a2.5 2.5 0 010 5H10" />
  </svg>

  <svg
    v-else-if="name === 'football'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="8" />
    <path d="M12 4l3 3-1 4-4 0-1-4 3-3z" />
    <path d="M8 10l-4 2M16 10l4 2M9 14l-2 4M15 14l2 4" />
  </svg>

  <svg
    v-else-if="name === 'volleyball'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="8" />
    <path d="M12 4c2.5 3 3 7 0 16" />
    <path d="M4 12c3-2.5 7-3 16 0" />
    <path d="M5.5 7c3 1 6 4 7 13" />
    <path d="M18.5 7c-3 1-6 4-7 13" />
  </svg>

  <svg
    v-else-if="name === 'basketball'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="12" cy="12" r="8" />
    <path d="M4 12h16M12 4v16" />
    <path d="M5.5 7c3 1.5 5 3.5 6 10" />
    <path d="M18.5 7c-3 1.5-5 3.5-6 10" />
  </svg>

  <svg
    v-else-if="name === 'gym'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <rect x="2.5" y="9" width="2.5" height="6" rx="0.6" />
    <rect x="19" y="9" width="2.5" height="6" rx="0.6" />
    <rect x="5" y="10.5" width="2" height="3" rx="0.4" />
    <rect x="17" y="10.5" width="2" height="3" rx="0.4" />
    <path d="M7 12h10" />
  </svg>

  <svg
    v-else-if="name === 'bike'"
    viewBox="0 0 24 24"
    :class="$props.class"
    fill="none"
    stroke="currentColor"
    stroke-width="1.3"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <circle cx="6" cy="16" r="4" />
    <circle cx="18" cy="16" r="4" />
    <path d="M6 16l4-8h5l3 8" />
    <path d="M10 8h2" />
    <path d="M15 8l-1-2h-1.5" />
  </svg>
</template>
